import React, { useEffect, useState } from 'react';
import './index.scss';
import {
    Button,
    Col,
    Divider,
    Tabs,
    Row,
    Typography,
    notification,
    Space,
    Form,
    Input, Upload, Spin, Select, Skeleton, InputNumber, Switch,
} from 'antd';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import arrowLeft from '../../../src/img/arrow-left.png';
import {
    UploadOutlined,
    ArrowLeftOutlined,
} from '@ant-design/icons';
import ContentForm from './ContentForm';
import API_SERVICE from 'shared/services/api-service';
import QuestionsPage from '../Questions/QuestionsPage';

const { TabPane } = Tabs;


interface Props {
    location: any;
}

const { Title } = Typography;
const { Option } = Select;
export default function ContentView(props: Props) {
    const { t } = useTranslation();
    const history: any = useHistory();
    const RouteParams: any = useParams();
    const [fetching, setFetching] = useState(false);
    const [item, setItem] = useState(null as any);
    const refreshItem = async () => {
        try {
            setFetching(true);
            const {
                data: { data },
            } = await API_SERVICE.fetchContentByIdAdmin(RouteParams['courseId'], RouteParams['curriculumId'], RouteParams['id']);
            setItem({
                ...data,
            });
        } catch (e) {
            notification.error({
                message: t(API_SERVICE.handleErrors(e)),
            });
        } finally {
            setFetching(false);
        }
    };
    useEffect(() => {
        if (RouteParams['id']) {
            refreshItem();
        } else {
            setFetching(false);
        }
    }, []);
    console.log(item);
    return (
        <div className={'list-page-wrapper'}>
            <div className='row'>
            <div className='col-sm-6 mb-3'>
                <div className='mr-4'>
                <span className='bg-back cursor-pointer' onClick={() => history.goBack()}><img src={arrowLeft} className="page-back" /></span>
                </div>
                <div><h3 className='mb-0'></h3></div>
            </div>
            </div>
            <Row gutter={30} justify={'space-between'} wrap={false}>
                <Col flex={'auto'}>
                    <Tabs defaultActiveKey="1">
                        <TabPane tab={t('Edit')} key="1">
                            <ContentForm fetching={fetching} item={item} refreshItem={refreshItem}
                                         location={props.location} hideHeader={true}/>
                        </TabPane>
                        {
                            item && item.type === 'quiz' && <TabPane tab={t('genDict.questions')} key="2">
                                <QuestionsPage location={props.location} hideHeader={true}/>
                            </TabPane>
                        }
                    </Tabs>
                </Col>
            </Row>
        </div>
    );
}
